import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {SingleValue} from 'react-select';
import InputSelect from '../../../../common/components/ui/InputSelect';
import {Currency} from '../../../../common/types';
import {currencies} from '../../../../common/enums';
import styles from './InputCurrency.module.scss';
import './CustomInputSelectStyles.scss';

type Option = { label: string, value: Currency };
type InputCurrencyProps = {
  isDisabled?: boolean;
  currencyOptions: Option[];
};

const InputCurrency = ({isDisabled = false, currencyOptions}: InputCurrencyProps) => {
  const [field, meta, helpersStatus] = useField<Currency>({name: 'currency'});
  const intl = useIntl();
  const placeholderLabel = intl.formatMessage({
    id: 'payment-currency-label', defaultMessage: 'Currency'
  });
  const handleChange = (currencyOption: SingleValue<Option>) => {
    helpersStatus.setValue(currencyOption?.value || currencies.NIS);
  };
  const [selectedValue] = currencyOptions.filter(option => option.value === field.value)

  return (
    <div className={styles.selectContainer}>
      <InputSelect
        <Option>
        {...field}
        {...meta}
        id={field.name}
        label={placeholderLabel}
        placeholder={placeholderLabel}
        value={selectedValue}
        defaultValue={currencyOptions[0]}
        options={currencyOptions}
        onChange={handleChange}
        isClearable={false}
        isSearchable={false}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default InputCurrency;
